<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      title="网站用户详情"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:'首页'}
      ,{path:'/website-user',breadcrumbName:'网站用户'}
      ,{path:'/website-user',breadcrumbName:'网站用户详情'}
      ] } }"
    />
    <div style="margin: 16px 16px">
      <a-row :gutter="20">
        <a-col :span="6">
          <a-card :bordered="false">
            <div class="account-center-detail">
              <p>
                <a-icon type="solution"/>
                姓: {{ form.data.firstName }}
              </p>
              <p>
                <a-icon type="solution"/>
                名: {{ form.data.lastName }}
              </p>
              <p>
                <a-icon type="mobile"/>
                电话: {{ form.data.phonePrefix }} {{ form.data.phone }}
              </p>
              <!--              <p>-->
              <!--                <a-icon type="property-safety"/>-->
              <!--                消费总额:{{ form.data.consumptionAmount }}-->
              <!--              </p>-->
              <p>
                <a-icon type="bars"/>
                订单总数: {{ table.query.total }}
              </p>
            </div>
          </a-card>
        </a-col>
        <a-col :span="18">
          <a-card
            :bordered="false"
            :tab-list="tabs"
            :active-tab-key="searchForm.data.status"
            @tabChange="key => onTabChange(key)">
            <div>
              <div>
                <a-form-model
                  label-position="top"
                  layout="vertical"
                  :model="searchForm.data">
                  <a-row :gutter="20">
                    <a-col :span="4">
                      <a-form-model-item label="购买时间">
                        <a-range-picker
                          style="width: 100%"
                          :show-time="{ format: 'HH:mm:ss' }"
                          format="YYYY-MM-DD HH:mm:ss"
                          :placeholder="['Start Time', 'End Time']"
                          v-model="searchForm.data.timeScope"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-model-item label="订单号">
                        <a-input v-model="searchForm.data.orderNo" allowClear/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-model-item label="交易单号">
                        <a-input v-model="searchForm.data.id" allowClear/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-model-item label="手机号">
                        <a-input v-model="searchForm.data.phone" allowClear/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-model-item label="操作">
                        <a-space>
                          <a-button
                            type="primary"
                            plain
                            icon="el-icon-search"
                            @click="getOrderList">{{ $t('SEARCH') || '查询' }}
                          </a-button>
                        </a-space>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
              </div>
              <div>
                <order-card
                  :shipped-order="shippedOrder"
                  :view-order-records="viewOrderRecords"
                  :edit-order-express="editOrderExpress"
                  :refund-order="refundOrder"
                  :completed-order="completedOrder"
                  :editable="true"
                  :order="order"
                  :key="order.id"
                  v-for="order in table.data"/>
                <a-empty v-if="table.data.length===0"/>
              </div>
              <a-pagination
                v-model="table.query.page"
                :total="table.query.total"
                show-size-changer
                :page-size="table.query.size"
                @showSizeChange="handleSizeChange"
                @change="handleSizeChange"
              >
                <template slot="buildOptionText" slot-scope="props">
                  <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                  <span v-if="props.value === '50'">全部</span>
                </template>
              </a-pagination>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <a-modal
      :footer="null"
      title="积分调整"
      width="30%"
      v-model="pointsForm.visible">
      <a-form-model v-model="pointsForm.data">
        <a-form-model-item label="分数" prop="changePoints">
          <a-input-number v-model="pointsForm.data.changePoints"/>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input v-model="pointsForm.data.remark"/>
        </a-form-model-item>
        <a-form-model-item label="">
          <a-button type="primary" @click="updateChangePoints">更新</a-button>
          <a-button @click="pointsForm.visible = false">{{ $t('CANCEL') || '取消' }}</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      title="发货信息"
      append-to-body
      size="50%"
      v-model="orderExpressForm.visible"
    >
      <order-express-list
        v-if="orderExpressForm.visible"
        :order-id="orderExpressForm.data.id"
      />
    </a-modal>
    <a-drawer
      title="订单记录"
      append-to-body
      v-model="orderRecordForm.visible">
      <order-record-list
        v-if="orderRecordForm.visible"
        :order-id="orderRecordForm.data.id"/>
    </a-drawer>
    <a-modal
      :footer="null"
      title="提示"
      v-model="form.visible">
      <order-edit
        v-if="form.visible"
        :order-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </order-edit>
    </a-modal>
  </div>
</template>

<script>
import {
  _queryOrders,
  _completedOrder,
  _refundOrder,
  _shippedOrder,
} from '@/api/websiteOrderApi';
import {
  _queryUser
} from '@/api/websiteUserApi';
import moment from 'moment';
import OrderCard from '@/components/OrderCardWebsite.vue';
import OrderEdit from '@/views/shop/order/OrderEdit.vue';
import OrderRecordList from '@/views/shop/order/OrderRecordList.vue';
import OrderExpressList from '@/views/shop/orderExpress/OrderExpressList.vue';

async function getOrderList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const timeScope = this.searchForm.data.timeScope && this.searchForm.data.timeScope.length === 2
    ? this.searchForm.data.timeScope : [null, null];
  const result = await _queryOrders({
    startAt: timeScope[0] ? moment(timeScope[0])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    endAt: timeScope[1] ? moment(timeScope[1])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    userId: this.userId,
    phone: this.searchForm.data.phone,
    status: this.searchForm.data.status === 'ALL' ? null : this.searchForm.data.status,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
}

function viewOrderRecords(orderId) {
  this.orderRecordForm.data.id = orderId;
  this.orderRecordForm.visible = true;
  this.$router.push(`/website-order/${orderId}/detail`);
}

async function shippedOrder(orderId) {
  this.$confirm({
    title: '是否发货？',
    content: '',
    onOk: async () => {
      await _shippedOrder(orderId);
      this.$message.success(this.$t('UPDATE_SUCCESS'));
      this.getOrderList();
    },
  });
}

async function refundOrder(orderId) {
  this.$confirm({
    title: '当前操作将使订单状态设为退款，请确认？',
    content: '',
    onOk: async () => {
      await _refundOrder(orderId);
      this.$message.success('申请退款成功');
      this.getOrderList();
    },
  });
}

async function completedOrder(orderId) {
  this.$confirm({
    title: '订单是否已经完成？',
    content: '',
    onOk: async () => {
      await _completedOrder(orderId);
      this.$message.success(this.$t('UPDATE_SUCCESS'));

      this.getOrderList();
    },
  });
}

function editOrderExpress(orderId) {
  this.orderExpressForm.data.id = orderId;
  this.orderExpressForm.visible = true;
}

async function getUser() {
  const result = await _queryUser(this.userId);
  if (result) {
    this.form.data.firstName = result.firstName;
    this.form.data.lastName = result.lastName;
    this.form.data.phone = result.phone;
    this.form.data.phonePrefix = result.phonePrefix;
    // this.form.data.points = result.points;
    this.form.data.consumptionAmount = result.consumptionAmount;
  }
}

function changePoints() {
  this.pointsForm.data.remark = '';
  // this.pointsForm.points = 0;
  this.pointsForm.visible = true;
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

function handleSizeChange(val) {
  this.table.query.size = val;
  this.getOrderList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getOrderList();
}

function onTabChange(key) {
  this.searchForm.data.status = key;
  this.table.query.page = 1;
  this.getOrderList();
}

export default {
  name: 'WebsiteUserEdit',
  components: {
    OrderExpressList,
    OrderRecordList,
    OrderEdit,
    OrderCard,
  },
  props: {
    userId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    userId() {
      if (this.userId) {
        this.getUser();
      }
    },
  },
  methods: {
    onCancel,
    getUser,
    getOrderList,
    handleSizeChange,
    handlePageChange,
    changePoints,
    onTabChange,
    viewOrderRecords,
    shippedOrder,
    editOrderExpress,
    refundOrder,
    completedOrder,
  },
  data() {
    return {
      tabs: [{
        key: 'ALL',
        tab: '全部订单',
      }, {
        key: 'UN_PAID',
        tab: '未支付',
      }, {
        key: 'UN_SHIPPED',
        tab: '未发货',
      }, {
        key: 'TO_BE_SHIPPED',
        tab: '待收货',
      }, {
        key: 'TRANSACTION_COMPLETED',
        tab: '交易完成',
      }, {
        key: 'REFUND_COMPLETED',
        tab: '已退款',
      }, {
        key: 'CANCEL',
        tab: '已取消',
      }],
      currentTab: 'order',
      searchForm: {
        data: {
          status: 'ALL',
          timeScope: [],
          phone: '',
        },
      },
      orderExpressForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      orderRecordForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      pointsForm: {
        visible: false,
        data: {
          changePoints: 0,
          remark: '',
        },
      },
      form: {
        data: {
          firstName: '',
          lastName: '',
          phone: '',
          phonePrefix: '',
          // grade: '',
          // points: 0,
          consumptionAmount: 0,
        },
        title: '',
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  created() {
    if (this.userId) {
      this.getUser();
      this.getOrderList();
    }
  },
};
</script>
<style scoped>
.account-center-detail i {
  position: absolute;
  height: 14px;
  width: 14px;
  left: 0px;
  top: 4px;
}

.account-center-detail .title {
  background-position: 0px 0px;
}

.account-center-detail p {
  margin-bottom: 8px;
  padding-left: 26px;
  position: relative;
}

</style>
